import {Routes, Route, Navigate} from 'react-router-dom';
import Error from '../pages/Error';
// import Auth from "../pages/Auth";
import Logout from "../pages/Auth/Logout";
import Home from '../pages/public/Home';
import Product from "../pages/public/Product";
import Dashboard from "../pages/private/Dashboard";
import Orders from "../pages/private/Dashboard/Orders";
// import AddStaff from '../pages/private/Dashboard/AddStaff/CreatePopup';
import Item from '../pages/private/Dashboard/Item';
import Stafflist from '../pages/private/Dashboard/AddStaff';
import Profile from "../pages/private/Dashboard/Profile/Profile.jsx"
import QRManage from '../pages/private/Dashboard/QRManage/QRManage.jsx';
import PendingOrders from '../pages/private/Dashboard/PendingOrders';
import Login from "../pages/Auth/Login";
import Redirect from "../pages/Auth/Login/Redirect";
import Signup from "../pages/Auth/Signup";
import ForgotPassword from "../pages/Auth/ForgotPassword";
import RevenueDashboard from '../pages/private/Dashboard/Revenue'
import CounterOrder from '../pages/private/Dashboard/CounterOrder'
import OrderHistory from '../pages/private/Dashboard/OrderHistory'
import FDOrderHistory from '../pages/private/Dashboard/FoodDeliveryAdmin/OrderHistory'
import FDOrders from '../pages/private/Dashboard/FoodDeliveryAdmin/Orders'
import FDMenuManagement from '../pages/private/Dashboard/FoodDeliveryAdmin/MenuManagement'
import FDStaffManagement from '../pages/private/Dashboard/FoodDeliveryAdmin/StaffManagement'
import FDDiscounts from '../pages/private/Dashboard/FoodDeliveryAdmin/DiscountsManagement'
import FDSettings from '../pages/private/Dashboard/FoodDeliveryAdmin/Settings'
import FDNotifications from '../pages/private/Dashboard/FoodDeliveryAdmin/Notifications'
import FDRatings from '../pages/private/Dashboard/FoodDeliveryAdmin/Ratings'
import FDPayouts from '../pages/private/Dashboard/FoodDeliveryAdmin/Payouts'
import FDInvoices from '../pages/private/Dashboard/FoodDeliveryAdmin/Invoices'
import FDMarketingPoster from '../pages/private/Dashboard/FoodDeliveryAdmin/MarketingPoster'
import FDDeliveryPrice from '../pages/private/Dashboard/FoodDeliveryAdmin/DeliveryPrice'
import FDStoreTiming from '../pages/private/Dashboard/FoodDeliveryAdmin/StoreTiming'
import FDRevenue from '../pages/private/Dashboard/FoodDeliveryAdmin/Revenue'
import FDGSTDetails from '../pages/private/Dashboard/FoodDeliveryAdmin/GSTDetails'
import MenuTextExtractor from '../pages/private/Dashboard/Item/MenuTextExtractor.jsx';
import Receipt  from '../pages/public/Receiept';
import StockManagement from '../pages/private/Dashboard/StockManagement/index.jsx';
import Report from '../pages/private/Dashboard/Report/index.jsx';
import RoomDetails from '../pages/private/Dashboard/RoomDetails/index.jsx';
import EndDay from '../pages/private/Dashboard/EndDay/index.jsx';
import Cashbook from '../pages/private/Dashboard/Cashbook/index.jsx'
import FoodDeliveryAdmin from '../pages/private/Dashboard/FoodDeliveryAdmin'
const RoutesContainer = () => {
  return (
    <Routes>
      {/* Legacy direct paths for fooddelivery - provide absolute routes so direct URLs land on FD admin */}
      <Route path='/fooddelivery' element={<Navigate to={'/dashboard/fooddelivery'} replace />} />
      <Route path='/fooddelivery/orders' element={<FDOrderHistory />} />
      <Route path='/' element={ <Home /> } />
      {/*<Route path='/auth' element={ <Auth /> } />*/}
      <Route path='/dashboard' element={ <Dashboard /> }>
        <Route path='orders' element={ <Orders /> } />
        <Route path='revenue' element={ <RevenueDashboard /> } />
        <Route path='counterorder' element={ <CounterOrder /> } />
        <Route path='orderhistory' element={ <OrderHistory /> } />
        <Route path='' element={ <Orders /> } />
        <Route path='addstaff' element={ <Stafflist /> } />
        <Route path='stockmanagement' element={ <StockManagement /> } />
        <Route path='item' element={ <Item /> } />
        <Route path='profile' element={ <Profile /> } />
        <Route path='qrmanage' element={ <QRManage /> } />
        <Route path='room-details' element={ <RoomDetails /> } />
        <Route path='pendingorders' element={ <PendingOrders /> } />
        <Route path='menu' element={ <MenuTextExtractor /> } />
        <Route path='report' element={ <Report /> } />
        <Route path='day-end' element={<EndDay />} />
        <Route path='cashbook' element={<Cashbook />} />
        <Route path='fooddelivery' element={ <FoodDeliveryAdmin /> } />
        <Route path='fooddelivery/orders' element={ <FDOrders /> } />
        <Route path='fooddelivery/menu' element={ <FDMenuManagement /> } />
        <Route path='fooddelivery/staff' element={ <FDStaffManagement /> } />
        <Route path='fooddelivery/discounts' element={ <FDDiscounts /> } />
        <Route path='fooddelivery/revenue' element={ <FDRevenue /> } />
        <Route path='fooddelivery/settings' element={ <FDSettings /> } />
        <Route path='fooddelivery/notifications' element={ <FDNotifications /> } />
        <Route path='fooddelivery/ratings' element={ <FDRatings /> } />
        <Route path='fooddelivery/payouts' element={ <FDPayouts /> } />
        <Route path='fooddelivery/invoices' element={ <FDInvoices /> } />
        <Route path='fooddelivery/order-history' element={ <FDOrderHistory /> } />
        <Route path='fooddelivery/gst-details' element={ <FDGSTDetails /> } />
        <Route path='fooddelivery/posters' element={ <FDMarketingPoster /> } />
        <Route path='fooddelivery/delivery-price' element={ <FDDeliveryPrice /> } />
        <Route path='fooddelivery/store-timing' element={ <FDStoreTiming /> } />
      </Route>
      <Route path='/redirect' element={ <Redirect /> } />
      <Route path='/receipt' element={ <Receipt /> } />
      <Route path='/login' element={ <Login /> } />
      <Route path='/signup' element={ <Signup /> } />
      <Route path='/logout' element={ <Logout /> } />
      <Route path='/forgot-password' element={ <ForgotPassword /> } />
      <Route path='/product' element={ <Product /> } />
      <Route path='*' element={ <Error /> } />
    </Routes>
  )
}

export default RoutesContainer;